<template>
  <div class="container">
    <div class="row">
      <div class="col-md-8" style="margin:0 auto">
        <div class="questionHeader">
          <img src="../../assets/img/lumi.png" alt />
          <span>问卷调查</span>
        </div>
        <div class="questionStatus">
          <img src="../../assets/img/success.png" alt />
          <p>您的问卷已经提交，感谢您的参与</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.questionHeader {
  padding: 2rem;
  font-size: 20px;
  margin-bottom: 80px;
  span {
    padding-left: 20px;
  }
  img {
    width: 48px;
  }
}
.questionStatus {
  text-align: center;
  font-size: 20px;
  // border: 2px solid #bfbfbf;
  padding: 30px 10px;
  margin: 1rem;
  p {
    margin-top: 20px;
    font-size: 16px;
  }
  img {
    width: 48px;
  }
}
</style>
